export enum GTM_EVENTS {
  registrationComplete = 'registration_complete',
  depositSuccessful = 'deposit_successful',
  firstDepositSuccessful = 'first_deposit_successful',
  uniqueReferrerRegister = 'unique_referrer_register'
}
